<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :filter-names="filterNames"
      search-label="search"
      vertical-scroll
      @filterOption="onFiltersChange"
    >
      <template v-slot:unit="{ item }">
        <div>
          <span v-if="item.geofence_type === 'polygon'">
            {{ item.area || calculateArea(item) || "Calculating... " }}
            <span class="text-muted"> (Area m²) </span>
          </span>
          <span v-if="item.geofence_type === 'circle'">
            {{ item?.radius ? item.radius.toFixed(2) : "-" }}
            <span class="text-muted"> (Radius) </span>
          </span>
        </div>
      </template>
      <template v-slot:count="{ item }">
        <div>
          <span v-if="item.vehicles.length > 0">
            <span v-if="item.vehicles.length > 1">
              <span>{{ item?.vehicles[0] }}</span>
              <span class="text-muted">
                (+{{ item.vehicles.length - 1 }} Vehicles)
              </span>
            </span>
            <span v-else>
              <span>
                {{ item?.vehicles[0] }}
              </span>
              <span class="text-muted"> (Vehicle) </span>
            </span>
          </span>
          <!--  -->
          <span v-if="item.groups.length > 0">
            <span v-if="item.groups.length > 1">
              <span>{{ item?.groups[0] }}</span>
              <span class="text-muted">
                (+{{ item.groups.length - 1 }} Groups)
              </span>
            </span>
            <span v-else>
              <span>
                {{ item?.groups[0] }}
              </span>
              <span class="text-muted"> (Group) </span>
            </span>
          </span>
        </div>
      </template>

      <template v-slot:is_active="{ item }">
        <div>
          {{ item?.is_active ? "Active" : "Inactive" }}
          <!-- <status-badge :status="item?.is_active ? 'Active' : 'Inactive'" /> -->
        </div>
      </template>
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-select
            v-model="customFilters.route_id"
            filled
            dense
            :loading="isRoute"
            :items="routeList"
            item-text="name"
            item-value="id"
            :label="$t('select_route')"
            clearable
            @change="fetchData"
          />
        </v-card>
      </template>
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <div class="d-flex">
          <router-link to="geofence/add">
            <v-btn
              v-if="isCreate"
              color="primary"
              dark
            >
              {{ $t("add_new") }}
            </v-btn>
          </router-link>

          <!-- <edit-modal
            v-if="(isView || isEdit) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          /> -->
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
          <!--  -->
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>

    <!-- <section>
      <locations-map />
    </section> -->
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    // StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    // CreateModal: () => import("./dialogs/CreateLocations.vue"),
    // EditModal: () => import("./dialogs/EditLocations.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      // module_name: "csmsChargeStations", //vuex module name which define in Store Index
      permissions: {
        view: "geofence.view",
        create: "live-tracking.list",
        edit: "live-tracking.list",
        delete: "live-tracking.list",
      },

      //
      locationModal: false,

      filters: {},
      subFilters: {},
      //
      customFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "geofence/getLoading",
      meta: "geofence/getMeta",
      list: "geofence/getList",
      //
      isRoute: "geofence/getLoading",
      routeList: "geofence/getRouteList",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("name"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        ...(this.authUser.user_nature == "fleet"
          ? [
              {
                text: this.$t("manufacturer"),
                align: "left",
                sortable: false,
                value: "tenant_name",
              },
            ]
          : []),
        {
          text: this.$t("type"),
          align: "left",
          sortable: false,
          cellClass: "text-capitalize",
          value: "geofence_type",
        },
        {
          // text: this.$t("count"),
          text: "Area / Radius",
          align: "left",
          sortable: true,
          value: "unit",
        },
        {
          // text: this.$t("count"),
          text: "Vehicles / Groups (Count)",
          align: "left",
          sortable: true,
          value: "count",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "is_active",
        },
        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];
      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      // if (this.authUser.isAdmin) {
      //   return ["make_type"];
      // } else {
      return ["search"];
      // }
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {
    if (this.$route?.query?.route_id) {
      this.customFilters.route_id = parseInt(this.$route?.query?.route_id);
      this.getVehicleList({ route_id: this.customFilters.route_id });
    }
    this.getRouteList();
    // this.$store.dispatch("geofence/setLoadingValue", true);
  },
  beforeDestroy() {
    const params = {
      name: "geofence",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = {
        ...this.options,
        ...this.customFilters,
      };
      await this.$store.dispatch("geofence/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
        // this.calculatePolygonArea(this.list);
      });
    },
    async getRouteList() {
      await this.$store.dispatch("geofence/routeList");
    },
    calculateArea(item) {
      const arr = item?.polygon;
      if (arr.length > 0) {
        this.$gmapApiPromiseLazy().then(() => {
          if (window.google?.maps?.geometry) {
            // const { maps } = map;
            // const path = arr.polygon.map((coord) =>
            //   maps.LatLng(coord[0], coord[1])
            // );
            if (arr && Array.isArray(arr)) {
              const path = arr.map(
                (coord) => new window.google.maps.LatLng(coord[0], coord[1])
              );
              const area =
                window.google.maps.geometry.spherical.computeArea(path);

              this.$set(item, "area", area.toFixed(2)); //  Make area reactive
              // item.area = area.toFixed(2);
            }
          }
        });
      } else {
        return false;
      }
    },
    calculatePolygonArea(list) {
      this.$gmapApiPromiseLazy().then(() => {
        if (window.google?.maps?.geometry) {
          list.forEach((el) => {
            if (el?.polygon && Array.isArray(el.polygon)) {
              const path = el.polygon.map(
                (coord) => new window.google.maps.LatLng(coord[0], coord[1])
              );
              const area =
                window.google.maps.geometry.spherical.computeArea(path);
              this.$set(el, "area", (area / 1000000).toFixed(2)); //  Make area reactive
            }
          });
          // Optional: commit updated list
          this.$store.commit("geofence/SET_LIST", list);
        } else {
          return 0;
        }
      });
    },

    // Edit Geofence
    editItem(item) {
      const params = {
        id: item.id,
      };
      this.$router.push({ name: "geofence_edit", params });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("geofence/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
    //
  },
};
</script>
<style lang="sass" scoped>
.map-button
  height: 41px !important
  margin-right: 5px

.btn-disabled
  pointer-events: none !important
  background-color: #8f8f8f !important

:deep .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined).v-input--dense .v-select__slot > input
  font-size: 0.875rem !important
</style>
